export default defineNuxtRouteMiddleware((to) => {
  const { status } = useAuth()
  const error = useError()
  // Return immediately if user is already authenticated or an error occurred
  if (status.value === 'authenticated' || error.value) {
    return
  }

  // Store the path the user was trying to access
  useUnauthorizedRedirectCookie().value = to.fullPath

  // Redirect to login page
  const localePath = useLocalePath()
  return navigateTo(localePath('index-signin'))
})
